<template>
    <toolbar-option>
        <template slot="primary">
            <button-group
                :value="value"
                :options="options"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'text-alignment',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Text Alignment',
            tailwindDefinitionProp: 'textAlign',
            value: '',
        };
    },

    methods: {
        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.value;
        },
    },
};
</script>
